<template>
  <div class="phd-modal-overlay" @click="$emit('close')">
    <div class="phd-modal-content" @click.stop>
      <div class="phd-modal-header">
        <h3>{{ phd ? 'Редактировать ПХД' : 'Добавить ПХД' }}</h3>
        <button class="phd-modal-btn phd-modal-btn-default" @click="$emit('close')">&times;</button>
      </div>
      <div class="phd-modal-body">
        <div class="phd-modal-form-group">
          <label>ФИО:</label>
          <input
            v-model="formData.fio"
            type="text"
            class="phd-modal-form-control"
            :class="{ 'is-invalid': errors.fio }"
            placeholder="Введите ФИО"
          >
          <div v-if="errors.fio" class="phd-modal-invalid-feedback">{{ errors.fio }}</div>
        </div>

        <div class="phd-modal-form-group">
          <label>Дата рождения:</label>
          <date-picker
            v-model="formData.birthday"
            format="DD.MM.YYYY"
            value-type="YYYY-MM-DD"
            :disabled-date="disabledDates"
          />
          <div v-if="errors.birthday" class="phd-modal-invalid-feedback">{{ errors.birthday }}</div>
        </div>

        <div class="phd-modal-form-group">
          <label>Организация:</label>
          <input
            v-model="formData.org_name"
            type="text"
            class="phd-modal-form-control"
            :class="{ 'is-invalid': errors.org_name }"
            placeholder="Введите организацию"
          >
          <div v-if="errors.org_name" class="phd-modal-invalid-feedback">{{ errors.org_name }}</div>
        </div>

        <div class="phd-modal-form-group">
          <label>ИНН:</label>
          <input
            v-model="formData.inn"
            type="text"
            class="phd-modal-form-control"
            :class="{ 'is-invalid': errors.inn }"
            placeholder="Введите ИНН"
            maxlength="12"
          >
          <div v-if="errors.inn" class="phd-modal-invalid-feedback">{{ errors.inn }}</div>
        </div>

        <div class="phd-modal-form-group">
          <label>Дата начала:</label>
          <date-picker
            v-model="formData.begin_date"
            format="DD.MM.YYYY"
            value-type="YYYY-MM-DD"
            placeholder="Выберите дату начала"
          />
          <div v-if="errors.begin_date" class="phd-modal-invalid-feedback">{{ errors.begin_date }}</div>
        </div>

        <div class="phd-modal-form-group">
          <label>Дата окончания:</label>
          <date-picker
            v-model="formData.expire_date"
            format="DD.MM.YYYY"
            value-type="YYYY-MM-DD"
            placeholder="Выберите дату окончания"
          />
          <div v-if="errors.expire_date" class="phd-modal-invalid-feedback">{{ errors.expire_date }}</div>
        </div>
      </div>

      <div class="phd-modal-footer">
        <button class="phd-modal-btn phd-modal-btn-primary" @click="onSave">Сохранить</button>
        <button class="phd-modal-btn phd-modal-btn-default" @click="$emit('close')">Отмена</button>
      </div>
    </div>
  </div>
</template>

<script>
import '@/common/assets/styles/phd-modal.scss'

export default {
  name: 'PhdModal',

  props: {
    phd: { type: Object, default: null }
  },

  data() {
    return {
      formData: {
        id: null,
        fio: '',
        birthday: '',
        org_name: '',
        inn: '',
        begin_date: '',
        expire_date: ''
      },
      errors: {}
    }
  },

  watch: {
    'formData.begin_date'(newBeginDate, oldBeginDate) {
      if (newBeginDate && this.formData.expire_date && newBeginDate > this.formData.expire_date) {
        this.formData.expire_date = newBeginDate
      }
    }
  },

  created() {
    if (this.phd) {
      this.formData = { ...this.phd }
    }
  },

  methods: {
    disabledDates(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },

    validateForm() {
      this.errors = {}
      if (!this.formData.fio?.trim()) {
        this.errors.fio = 'ФИО обязательно для заполнения'
      }
      if (!this.formData.inn?.trim()) {
        this.errors.inn = 'ИНН обязателен для заполнения'
      } else if (!/^\d{10}|\d{12}$/.test(this.formData.inn)) {
        this.errors.inn = 'ИНН должен содержать 10 или 12 цифр'
      }
      if (!this.formData.begin_date) {
        this.errors.begin_date = 'Дата начала обязательна для заполнения'
      }
      if (!this.formData.expire_date) {
        this.errors.expire_date = 'Дата окончания обязательна для заполнения'
      }

      return Object.keys(this.errors).length === 0
    },

    onSave() {
      if (this.validateForm()) {
        this.$emit('save', this.formData)
      }
    }
  }
}
</script>
